import { captureRemixErrorBoundaryError } from '@sentry/remix';
import { useEffect } from 'react';
import { isRouteErrorResponse, useLocation, useRouteError } from 'react-router';

import PageLoadErrorEvent from '~/events/PageLoadErrorEvent';
import useRootData from '~/hooks/useRootData';

import Error404 from './Error404';

export default function PageLoadErrorBoundary({
  pageType
}: {
  pageType: string;
}) {
  const error = useRouteError();
  const location = useLocation();
  const { isBot } = useRootData();

  captureRemixErrorBoundaryError(error);

  useEffect(() => {
    const errorType = isRouteErrorResponse(error) ? 'loader' : 'render';
    const errorMessage = isRouteErrorResponse(error)
      ? `${error.status} ${error.statusText}`
      : error instanceof Error
        ? error.message.slice(0, 500)
        : 'Unknown error';

    new PageLoadErrorEvent({
      errorMessage,
      errorType,
      isBot,
      pageType,
      url: location.pathname + location.search
    }).send();
  }, [error, isBot, pageType, location]);

  return <Error404 />;
}
